// services/accountService.js
import axios from "axios";
import apiClient from "../api/apiClient";
import { AccountService_ApiEndPoint } from "./accoutEndpoints";

export const GetUserDetails = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetUserList);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const GetUserById = async (userId) => {
    try {
        // Construct the URL with userId
        const url = `${AccountService_ApiEndPoint.GetUserList}/${userId}`;
        const response = await apiClient.get(url);
        return response.data;
    } catch (error) {
        console.error(`Error fetching user with ID ${userId}:`, error);
        throw error;
    }
};

export const CreateUser = async (userData) => {
    try {


        // Use dynamic data from userData
        const apiData = {
            userName: userData.userName || userData.username,
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            password: userData.password,
            // Use userTypeID from userData if provided, otherwise default to 2
            userTypeID: userData.userTypeID,
            isAdmin: userData.isAdmin || userData.adminAccess || false,
            isActive: userData.isActive !== undefined ? userData.isActive : true,
            // Use managedClientIds from userData, default to empty array if not provided
            managedClientIds: userData.managedClientIds || []
        };

        // If userTypeName is provided, we might need to map it to userTypeID
        if (userData.userTypeName && !userData.userTypeID) {
            // You might need to map userTypeName to userTypeID here
            // This depends on your backend API
            const userTypeMap = {
                'Admin': 7,
                'Cager': 1,
                'Client': 2,
                'Consultant': 3,
                'Employee': 4,
                'List Agency': 5,
                'Vendor': 6
            };
            apiData.userTypeID = userTypeMap[userData.userTypeName];
        }

        // console.log('Sending user data to API:', apiData);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateUser,
            apiData
        );
        return response.data;
    } catch (error) {
        console.error("Error creating user:", error);
        throw error;
    }
};

export const UpdateUserById = async (userId, userData) => {
    try {
        // Construct the update URL with userId
        const url = `${AccountService_ApiEndPoint.UpdateUserById}/${userId}`;

        // Prepare the update data - similar to CreateUser but with only fields that can be updated
        const apiData = {
            userName: userData.userName || userData.username,
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            password: userData.password || '',
            userTypeID: userData.userTypeID,
            isAdmin: userData.isAdmin || userData.adminAccess || false,
            isActive: userData.isActive !== undefined ? userData.isActive : true,
            managedClientIds: userData.managedClientIds || []
        };


        // Handle userTypeName mapping if provided
        if (userData.userTypeName && !userData.userTypeID) {
            const userTypeMap = {
                'Admin': 7,
                'Cager': 1,
                'Client': 2,
                'Consultant': 3,
                'Employee': 4,
                'List Agency': 5,
                'Vendor': 6
            };
            apiData.userTypeID = userTypeMap[userData.userTypeName];
        }

        // console.log(`Updating user ID ${userId} with data:`, apiData);

        const response = await apiClient.put(url, apiData);

        return response.data;
    } catch (error) {
        console.error(`Error updating user with ID ${userId}:`, error);
        throw error;
    }
};

export const GetUserType = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetUserType);
        return response.data;
    } catch (error) {
        console.error("Error fetching user type:", error);
        throw error;
    }
};

export const GetManagedClientsUserModule = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetManagedClientsUserModule);
        return response.data;
    } catch (error) {
        console.error("Error fetching managed Clients:", error);
        throw error;
    }
};

export const GetManagedClients = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetManagedClients);
        return response.data;
    } catch (error) {
        console.error("Error fetching managed Clients:", error);
        throw error;
    }
};

export const DeleteUserById = async (userId) => {
    try {
        // Since DeleteUserById is now a function, call it with userId
        const url = AccountService_ApiEndPoint.DeleteUserById(userId);

        console.log(`Deactivating user with ID ${userId}`);
        console.log(`Full URL: ${url}`);

        const response = await apiClient.put(url);

        return response.data;
    } catch (error) {
        console.error(`Error deactivating user with ID ${userId}:`, error);
        throw error;
    }
};



//Client Maintainence

export const GetClientDetails = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetClientList);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const GetAllUsersInternalRoles = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetAllUsersInternalRoles);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const GetAccountingType = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetAccountingType);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const CreateClients = async (clientData) => {
    // console.log("clientData", clientData);



    try {
        // Construct the client data object from the provided clientData
        const apiData = {
            clientCode: clientData.clientCode,
            clientTypeID: clientData.clientTypeID,
            clientName: clientData.clientName,
            isActive: clientData.isActive !== undefined ? clientData.isActive : true,
            clientPhoneNumber: clientData.clientPhoneNumber,
            clientEmailAddress: clientData.clientEmailAddress,
            cagingOrgName: clientData.cagingOrgName,
            breOrgName: clientData.breOrgName,
            npAuthorizationNumber: clientData.npAuthorizationNumber,
            crid: clientData.crid,
            mid: clientData.mid,
            permitNumber: clientData.permitNumber,
            accountManagerID: clientData.accountManagerID || null,
            productionManagerID: clientData.productionManagerID || null,
            listManagerID: clientData.listManagerID || null,
            consultantID: clientData.consultantID || null,
            creativeDirectorID: clientData.creativeDirectorID || null,
            isThankYouProgramActive: clientData.isThankYouProgramActive !== undefined ? clientData.isThankYouProgramActive : false,
            addresses: clientData.addresses || [],
            contacts: clientData.contacts || [],
            accountingDetail: clientData.accountingDetail || null,
            clientContractInfo: clientData.clientContractInfo || '',

        };

        // If clientTypeName is provided but clientTypeID is not, map it
        if (clientData.clientTypeName && !clientData.clientTypeID) {
            const clientTypeMap = {
                'Standard': 1,
                'Premium': 2,
                'Enterprise': 3
                // Add more mappings as per your application
            };
            apiData.clientTypeID = clientTypeMap[clientData.clientTypeName];
        }

        // Validate required fields
        const requiredFields = ['clientCode', 'clientTypeID', 'clientName'];
        for (const field of requiredFields) {
            if (!apiData[field]) {
                throw new Error(`Missing required field: ${field}`);
            }
        }

        // console.log('Sending client data to API:', apiData);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateClients,
            apiData
        );
        return response.data;
    } catch (error) {
        console.error("Error creating client:", error);
        throw error;
    }
};


export const GetStateType = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetStateType);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const GetClientById = async (clientId) => {
    try {

        const url = AccountService_ApiEndPoint.GetClientById(clientId);
        const response = await apiClient.get(url);
        return response.data;
    } catch (error) {
        console.error(`Error fetching user with ID ${clientId}:`, error);
        throw error;
    }
};


export const UpdateClientById = async (clientId, clientData) => {
    try {
        const url = `${AccountService_ApiEndPoint.UpdateClientById}/${clientId}`;
        const response = await apiClient.put(url, clientData);
        return response;
    } catch (error) {
        console.error(`Error updating client with ID ${clientId}:`, error);
        throw error;
    }
};


export const DeleteClientById = async (clientId) => {
    try {
        const url = AccountService_ApiEndPoint.DeleteClientById(clientId);

        // console.log(`Deactivating client with ID ${clientId}`);
        // console.log(`Full URL: ${url}`);

        const response = await apiClient.delete(url);

        return response.data;
    } catch (error) {
        console.error(`Error deactivating user with ID ${clientId}:`, error);


        throw error;
    }
};






// Get all clients for the current user
export const GetClientPortal = async () => {
    try {
        // Get userId from localStorage (from login response)
        const userDataString = localStorage.getItem('userData');

        if (!userDataString) {
            throw new Error('User not authenticated. Please login again.');
        }

        const userData = JSON.parse(userDataString);
        const userId = userData.userId;

        if (!userId) {
            throw new Error('User ID not found. Please login again.');
        }



        // Use dynamic userId from localStorage
        const url = `${AccountService_ApiEndPoint.GetClientPortalList}${userId}`;

        const response = await apiClient.get(url);

        return response.data;
    } catch (error) {
        console.error('Error fetching client portal:', error);
        throw error;
    }
};

// Mark/Unmark client as favorite
export const MarkFavorite = async (clientID, isFavorite) => {
    try {
        // Get userId from localStorage (from login response)
        const userDataString = localStorage.getItem('userData');


        if (!userDataString) {
            throw new Error('User not authenticated. Please login again.');
        }

        const userData = JSON.parse(userDataString);
        const userId = userData.userId;

        if (!userId) {
            throw new Error('User ID not found. Please login again.');
        }

        const requestData = {
            userID: userId,
            clientID: clientID,
            isFavorite: isFavorite
        };

        // console.log('Marking favorite API call with data:', requestData);


        const endpoint = AccountService_ApiEndPoint.CreateFavorite;
        console.log('API Endpoint:', endpoint);

        const response = await apiClient.post(
            endpoint,
            requestData
        );

        // console.log('Favorite API response:', response.data);
        return response.data;

    } catch (error) {
        console.error('Error marking favorite:', error);

        // More detailed error logging
        if (error.response) {
            console.error('API Response Error:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
            // Throw a more descriptive error
            throw new Error(error.response.data?.message || `API Error: ${error.response.status}`);
        } else if (error.request) {
            console.error('No response received:', error.request);
            throw new Error('No response from server. Please check your connection.');
        } else {
            console.error('Error setting up request:', error.message);
            throw error;
        }
    }
};



// Get specific client details by clientId
export const GetParticularClientList = async (clientId) => {
    try {
        // Ensure clientId is provided
        if (!clientId) {
            throw new Error('Client ID is required');
        }

        // console.log(`Fetching client details for ID: ${clientId}`);

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetParticularClientList(clientId)
        );

        // console.log(`Client ${clientId} details:`, response.data);
        return response.data;
    } catch (error) {
        throw error;
    };
};


export const GetTimezoneType = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetTimezone);

        // console.log("Timezone API response:", response);

        // Transform the response to match what ContactModal expects
        if (response.data && response.data.isSuccess !== undefined) {
            // If response already has isSuccess property, return as-is
            return response.data;
        } else {
            // Wrap in expected structure
            return {
                isSuccess: true,
                data: response.data || []
            };
        }
    } catch (error) {
        // Return error structure
        return {
            isSuccess: false,
            message: error.message || "Failed to fetch timezones",
            data: []
        };
    }
};

// Create Contact API Function
export const CreateClientContact = async (contactData, stateOptions) => {
    try {
        // console.log('Creating contact with data:', contactData);

        // console.log('State options:', stateOptions);

        // Find state ID from state abbreviation
        let contactStateID = 0;
        if (contactData.contactStateID) {
            // If contactStateID is already a number, use it
            contactStateID = parseInt(contactData.contactStateID);
        } else if (contactData.stateAbbreviation && stateOptions && stateOptions.length > 0) {
            // If we have abbreviation, find the ID from stateOptions
            const state = stateOptions.find(s => s.value === contactData.stateAbbreviation);
            contactStateID = state ? state.contactStateID : 0;
        }



        // Map form data to API request format
        const apiPayload = {
            clientContactID: 0, // 0 for new contact
            clientId: contactData.clientId, // You need to pass clientId
            contactFirstName: contactData.contactFirstName || '',
            contactLastName: contactData.contactLastName || '',
            contactPosition: contactData.contactPosition || '',
            contactPhone: contactData.contactPhone || '',
            contactEmail: contactData.contactEmail || '',
            contactAddress: contactData.contactAddress || '',
            contactCity: contactData.contactCity || '',
            contactStateID: contactStateID,
            contactZipCode: contactData.contactZipCode || '',
            timeZoneID: parseInt(contactData.timeZoneID) || 0
        };

        // console.log('API Payload:', apiPayload);




        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateContact,
            apiPayload
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

// Update Contact API Function - FIXED VERSION
export const UpdateClientContact = async (clientId, contactId, contactData) => {
    try {
        // console.log(`Updating contact ${contactId} for client ${clientId}:`, contactData);

        // FIX: Use the correct field names from the contactData object
        const apiPayload = {
            clientContactID: parseInt(contactId) || 0,
            clientId: parseInt(clientId),
            contactFirstName: contactData.contactFirstName || contactData.firstName || '',
            contactLastName: contactData.contactLastName || contactData.lastName || '',
            contactPosition: contactData.contactPosition || contactData.jobTitle || '',
            contactPhone: contactData.contactPhone || contactData.phone || '',
            contactEmail: contactData.contactEmail || contactData.email || '',
            contactAddress: contactData.contactAddress || contactData.address || '',
            contactCity: contactData.contactCity || contactData.city || '',
            contactStateID: parseInt(contactData.contactStateID) || contactData.contactStateID || 0,
            contactZipCode: contactData.contactZipCode || contactData.zipCode || '',
            timeZoneID: parseInt(contactData.timeZoneID) || contactData.timeZoneID || 0
        };
        const response = await apiClient.put(
            AccountService_ApiEndPoint.UpdateContact(clientId, contactId),
            apiPayload
        );

        console.log('Update contact response:', response);
        return response.data;
    } catch (error) {
        console.error('Error updating contact:', error);
        throw error;
    }
};


// Get Contact API Function
export const GetClientContact = async (clientId, contactId) => {
    try {
        // console.log(`Fetching contact ${contactId} for client ${clientId}`);

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetContact(clientId, contactId)
        );

        // console.log('Get contact response:', response.data);

        // Ensure response has proper structure
        const responseData = response.data;
        if (responseData && responseData.success === undefined && responseData.isSuccess !== undefined) {
            // Map isSuccess to success for consistency
            return {
                ...responseData,
                success: responseData.isSuccess
            };
        }

        return responseData;
    } catch (error) {
        console.error('Error fetching contact:', error);
        throw error;
    }
};

// Get Contact details by id  API Function
export const GetClientContactDetailsById = async (clientId, contactId) => {
    try {
        // console.log(`Fetching contact ${contactId} for client ${clientId}`);

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetClientContactById(clientId, contactId)
        );

        // console.log('Get contact response:', response.data);

        // Ensure response has proper structure
        const responseData = response.data;
        if (responseData && responseData.success === undefined && responseData.isSuccess !== undefined) {
            // Map isSuccess to success for consistency
            return {
                ...responseData,
                success: responseData.isSuccess
            };
        }

        return responseData;
    } catch (error) {
        throw error;
    }
};

export const GetPermissions = async () => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetPermissions
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};


// Login Api 
export const LoginUser = async (email, password) => {
    try {
        const loginData = {
            email,
            password
        };

        const response = await apiClient.post(
            AccountService_ApiEndPoint.Login,
            loginData,
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        throw error; // Re-throw to handle in component
    }
};


export const RefreshToken = async () => {
    try {
        const response = await apiClient.post(
            AccountService_ApiEndPoint.RefreshToken,
            {},
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Forgot Password Api
export const ForgotPasswordApi = async (email) => {
    try {
        const forgotPasswordData = {
            email
        };


        const response = await apiClient.post(AccountService_ApiEndPoint.ForgotPassword,
            forgotPasswordData);


        // console.log("response----->", response)
        return response.data;
    } catch (error) {
        throw error; // Re-throw to handle in component
    }
};


// Resend Otp

export const ResendOtp = async (email) => {
    try {
        const resendData = {
            email: email
        };

        console.log('Resending OTP for email:', email);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.ResendOtp,
            resendData
        );
        return response.data;
    } catch (error) {
        throw error; // Re-throw to handle in component
    }
};


//Verified OTP

export const VerifyOtp = async (email, otp) => {
    try {
        const verifyData = {
            email: email,
            otp: otp.toString() // Ensure OTP is string if required
        };

        // console.log('Verifying OTP:', verifyData);

        // Verify OTP API endpoint
        const response = await apiClient.post(
            AccountService_ApiEndPoint.forgotPasswordVerifyOtp,
            verifyData
        );

        // console.log('Verify OTP response:', response);
        return response.data;
    } catch (error) {
        console.error("Error during OTP verification:", error);


        if (error.response) {
            console.error("Error response data:", error.response.data);
            console.error("Error response status:", error.response.status);


            const responseData = error.response.data;


            if (responseData.errors?.message) {

                const errorMessage = Array.isArray(responseData.errors.message)
                    ? responseData.errors.message[0]
                    : responseData.errors.message;
                throw new Error(errorMessage);
            }
            else if (responseData.message) {

                throw new Error(responseData.message);
            }
            else if (responseData.errors) {

                throw new Error(JSON.stringify(responseData.errors));
            }
            else {
                throw new Error('Invalid OTP');
            }
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error('Failed to send verification request.');
        }
    }
};

//Reset Password

export const ResetPasswordApi = async (email, otp, newPassword) => {
    try {
        const resetData = {
            email: email,
            otp: otp.toString(), // Ensure OTP is string
            newPassword: newPassword
        };
        const response = await apiClient.post(
            AccountService_ApiEndPoint.ResetPassword, // Make sure this endpoint is defined in your accountEndpoints.js
            resetData
        );

        return response.data;
    } catch (error) {
        // Detailed error handling
        if (error.response) {
            throw new Error(error.response.data.message || 'Password reset failed');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error('Failed to send reset password request.');
        }
    }
};


//Tallies

export const GetJobListById = async (clientId) => {
    try {
        // Ensure clientId is provided
        if (!clientId) {
            throw new Error('Client ID is required');
        }

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetJobList(clientId)
        );
        return response.data;
    } catch (error) {
        throw error;
    };
};

//GetTalliesListById

export const GetTalliesListById = async (jobId, clientId) => {
    try {
        // Ensure both parameters are provided
        if (!jobId || !clientId) {
            throw new Error('Both jobId and clientId are required');
        }

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetTalliesList(jobId, clientId)
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};



export const GetMetricsDataById = async (clientId) => {
    try {
        // Ensure clientId is provided
        if (!clientId) {
            throw new Error('Client ID is required');
        }
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetMetricsData(clientId)
        );
        return response.data;
    } catch (error) {
        throw error;
    };
};

export const GetJobsDataById = async (clientId) => {
    try {
        // Ensure clientId is provided
        if (!clientId) {
            throw new Error('Client ID is required');
        }

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetJobsData(clientId)
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching client details for ID ${clientId}:`, error);
        throw error;
    };
};

//JOB Module

export const GetJobTypes = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetJobType);
        return response.data;


    } catch (error) {
        throw error;
    }
};


export const GetAccountingStatus = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetAccountingStatus);
        return response.data;


    } catch (error) {
        throw error;
    }
};



export const GetJobTechniques = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetTechniques);
        return response.data;


    } catch (error) {
        throw error;
    }
};


export const GetJobIssues = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetIssuesList);
        return response.data;


    } catch (error) {
        throw error;
    }
};


export const GetEstimateStatus = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetEstimateStatus);
        return response.data;


    } catch (error) {
        throw error;
    }
};




export const SearchJobList = async (searchParams) => {
    try {
        const formattedParams = {
            clientIds: searchParams.clientIds || [],
            mailDateFrom: searchParams.mailDateFrom || null,
            mailDateTo: searchParams.mailDateTo || null,
            jobTypeId: searchParams.jobTypeId || null,
            jobCode: searchParams.jobCode || null,
            mailCode: searchParams.mailCode || null
        };
        const response = await apiClient.post(
            AccountService_ApiEndPoint.SearchJobList,
            formattedParams
        );

        return response.data;

    } catch (error) {

        // Log detailed error information
        if (error.response) {
        } else if (error.request) {
        } else {
        }

        throw error;
    }
};


export const GetJobDetailsById = async (jobCode) => {
    try {

        const endpoint = AccountService_ApiEndPoint.GetJobDetailsById(jobCode);

        const response = await apiClient.get(endpoint);
        return response.data;

    } catch (error) {
        throw error;
    }
};


export const GetListSummaryById = async (jobCode) => {
    try {
        // Ensure clientId is provided
        if (!jobCode) {
            throw new Error('jobCode is required');
        }

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetListSummary(jobCode)
        );
        return response.data;
    } catch (error) {
        throw error;
    };
};


export const GetJobDetailsbyUserId = async (userId) => {

    try {

        const userDataString = localStorage.getItem('userData');

        if (!userDataString) {
            throw new Error('User not authenticated. Please login again.');
        }

        const userData = JSON.parse(userDataString);
        const userId = userData.userId;

        if (!userId) {
            throw new Error('User ID not found. Please login again.');
        }
        const url = `${AccountService_ApiEndPoint.GetJobDetailsbyUserId}?id=${userId}`;

        const response = await apiClient.get(url);
        return response.data;



    } catch (error) {
        throw error;
    };
};



// Create New Job
export const CreateNewJobs = async (jobData) => {
    try {
        const apiPayload = {
            jobName: jobData.jobName || '',
            jobCode: jobData.jobCode || '',
            jobTypeID: jobData.jobTypeID || null,
            firstMailDate: jobData.firstMailDate || null,
            clientID: jobData.clientID || null,
            productionManagerID: jobData.productionManagerID || null,
            copywriter: jobData.copywriter || '',
            accountingStatusID: jobData.accountingStatusID || null,
            estimateStatusID: jobData.estimateStatusID || null,
            techniqueID: jobData.techniqueID || null,
            issueID: jobData.issueID || null,
            inventory: jobData.inventory || '',
            notes: jobData.notes || '',
            createdByUserId: jobData.createdByUserId || 0
        };

        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateNewJob,
            apiPayload
        );

        // Return response data directly
        return response.data;
    } catch (error) {
        if (error.response?.status === 201) {
            return error.response.data;
        }
        throw error;
    }
};


export const DeleteJobsById = async (jobId) => {
    try {
        const url = AccountService_ApiEndPoint.DeleteJobsById(jobId);
        const response = await apiClient.delete(url);

        return response.data;
    } catch (error) {
        throw error;
    }
};


// Correct implementation
export const UpdateJobsById = async (jobId, jobData) => {
    try {
        const url = `${AccountService_ApiEndPoint.UpdateJobsById(jobId)}`;

        const response = await apiClient.put(url, jobData);
        return response.data; // Return response.data instead of full response
    } catch (error) {
        throw error;
    }
};

export const UpdateAccountingStatus = async (updates) => {
    try {
        const url = `${AccountService_ApiEndPoint.AccountingStatusUpdateDropdown}`;

        const response = await apiClient.put(url, { updates });
        return response.data;
    } catch (error) {
        throw error;
    }
};



export const DeleteMailCodeById = async (jobId, mailDetailIds) => {
    try {
        const url = AccountService_ApiEndPoint.DeleteMailDetails(jobId);

        // Send the request body with mailDetailIds array
        const response = await apiClient.delete(url, {
            data: { mailDetailIds: mailDetailIds }  // This sends the body with DELETE request
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const PostageMasterApi = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.PostageMasterApi);
        return response.data;
    } catch (error) {
        throw error;
    }
};




export const ListNameDropdown = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.ListNameDropdown);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ListSegment = async (listMasterID) => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.ListSegment(listMasterID));
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const CreateListSegmentValue = async (payload) => {
    try {
        const apiPayload = {
            listSegment: payload.listSegment || '',
            listMasterID: payload.listMasterID || 0
        };

        if (!apiPayload.listMasterID) {
            throw new Error('listMasterID is required to create a segment');
        }

        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateListSegmentValue,
            apiPayload
        );

        return response.data;
    } catch (error) {
        // 201 is success — handle the axios quirk if it exists
        if (error.response?.status === 201) {
            return error.response.data || { success: true, status: 201 };
        }
        throw error;
    }
};

export const CreateListName = async (payload) => {
    try {
        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateListName,
            payload
        );
        return response.data;
    } catch (error) {
        console.error("Error creating list name:", error);
        throw error;
    }
};


export const CreateNewListSummary = async (jobId, apiPayload) => {
    try {
        const numericJobId = jobId?.jobId || jobId;

        if (!numericJobId) {
            throw new Error('Job ID is required');
        }

        // Normalize to array (bulk-friendly)
        const payloadArray = Array.isArray(apiPayload)
            ? apiPayload
            : [apiPayload];

        const mailDetails = payloadArray.map(item => ({
            mailCode: item.mailCode || '',
            listName: item.listName || '',
            listSegment: item.listSegment || '',
            firstMailDate: item.firstMailDate || new Date().toISOString().split('T')[0],
            endMailDate: item.endMailDate || new Date().toISOString().split('T')[0],
            mailNotes: null,
            postageID: item.postageID || 1,
            test: item.test || '',
            totalMailed: Number(item.totalMailed) || 0,
            nonDonors: Number(item.nonDonors) || 0,
            donations: Number(item.donors || item.donations) || 0,
            income: Number(item.income) || 0,
            responseRate: Number(item.responseRate) || 0,
            averageGift: Number(item.averageGift) || 0,
            cost: Number(item.cost) || 4000,
            net: Number(item.net) || 0,
            incomePerLetter: Number(item.incomePerLetter) || 0,
            costPerLetter: Number(item.costPerLetter) || 0,
            netPerLetter: Number(item.netPerLetter) || 0,
            returnOnInvestment: Number(item.returnOnInvestment) || 0,
        }));

        const finalPayload = { mailDetails };

        console.log('CreateNewListSummary - Job ID:', numericJobId);
        console.log('CreateNewListSummary - Payload:', finalPayload);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateNewListSummary(numericJobId),
            finalPayload
        );

        return response.data;
    } catch (error) {
        console.error('Error in Create List Summary:', error);
        throw error;
    }
};



export const MailCodeUpdate = async (jobId, updates) => {
    try {
        if (!jobId) {
            throw new Error('Job ID is required');
        }

        if (!Array.isArray(updates) || updates.length === 0) {
            return {
                updatedCount: 0,
                errorCount: 0,
                message: 'No rows to update'
            };
        }
        const payload = { updates };

        const response = await apiClient.post(
            AccountService_ApiEndPoint.UpdatedMailCodeList(jobId),
            payload
        );

        if (response?.data?.data?.errorCount > 0) {
            throw new Error(response.data.data.message);
        }
        return response.data;

    } catch (error) {

        throw error;
    }
};

export const GetJobFiles = async (jobId) => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetJobFiles(jobId));
        return response.data;
    } catch (error) {
        console.error("Error fetching job files:", error);
        throw error;
    }
};

export const UploadJobFile = async (jobId, formData) => {
    try {
        const response = await apiClient.post(
            AccountService_ApiEndPoint.UploadJobFile(jobId),
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
    }
};

export const DeleteJobFile = async (jobId, fileId) => {
    try {


        const response = await apiClient.delete(
            AccountService_ApiEndPoint.DeleteJobFile(jobId),
            {
                params: { fileId },
                headers: {
                    'Content-Type': 'application/json',     // Skip preflight
                }
            }
        );

        return response.data;
    } catch (error) {

        throw error;
    }
};


export const GetDocumentTypesDropdown = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetDocumentTypes);
        return response.data;
    } catch (error) {
        console.error("Error fetching document types:", error);
        throw error;
    }
};


export const UploadTalliesIntegration = async (listData, talliesRows) => {
    try {
        // Transform your listData to match API requirements
        const apiPayload = {
            batchDate: listData.batchDate,
            returnsType: listData.returnsType || "Non-Cumulative",
            batchNumber: listData.batchNumber || "",
            rows: talliesRows.map((row, index) => ({
                rowNumber: index,
                mailCode: row.mailCode || '',
                donations: row.donations || 0,
                nonDonors: row.nonDonors || 0,
                amount: row.amount || 0
            }))
        };

        // console.log('API Payload:', apiPayload);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.UploadTallies,
            apiPayload
        );

        return response.data;
    } catch (error) {

        if (error.response?.status === 201) {
            return error.response.data;
        }
        throw error;
    }
};

export const GetTalliesBatches = async () => {
    try {
        const response = await apiClient.get(
            `${AccountService_ApiEndPoint.GetTalliesBatches}`
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


// Unified delete function for both entire batch and specific rows

export const DeleteTalliesRows = async (batchNumber, requestData) => {
    try {
        // requestData should contain tallyUploadId and optionally tallyIds
        // Format expected: { tallyUploadId: "string", tallyIds?: number[] }

        const response = await apiClient.delete(
            `${AccountService_ApiEndPoint.DeleteBatches.replace('{batchNumber}', batchNumber)}`,
            {
                data: requestData  // Should include tallyUploadId and optionally tallyIds
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error deleting tallies rows:", error);
        throw error;
    }
};


export const GetBatchDetails = async (tallyUploadId) => {
    try {
        if (!tallyUploadId) {
            throw new Error("Batch number is required");
        }

        const endpoint = AccountService_ApiEndPoint.GetBatchDetails(tallyUploadId);
        const response = await apiClient.get(endpoint);

        return response.data;
    } catch (error) {
        console.error(`Error fetching details for batch ${tallyUploadId}:`, error);
        throw error;
    }
};



export const SaveBatchData = async (batchNumber, saveData) => {
    try {
        if (!batchNumber) {
            throw new Error("Batch number is required");
        }

        if (!saveData) {
            throw new Error("Save data is required");
        }

        // Validate required fields in saveData
        if (!saveData.tallyUploadID) {
            throw new Error("tallyUploadID is required in save data");
        }

        if (!saveData.batchDate) {
            throw new Error("batchDate is required in save data");
        }

        if (!saveData.updatedRows || !Array.isArray(saveData.updatedRows)) {
            throw new Error("updatedRows array is required in save data");
        }

        const endpoint = AccountService_ApiEndPoint.SaveBatchData(batchNumber);
        const response = await apiClient.post(endpoint, saveData);

        return response.data;
    } catch (error) {
        console.error(`Error saving batch data for batch ${batchNumber}:`, error);
        throw error;
    }
};

export const UpdateBatchDetails = async ({ tallyUploadId, newBatchNumber, newBatchDate }) => {
    try {
        // Validate required parameters
        if (!tallyUploadId) {
            throw new Error("Tally upload ID is required");
        }

        if (!newBatchNumber) {
            throw new Error("New batch number is required");
        }

        if (!newBatchDate) {
            throw new Error("New batch date is required");
        }

        // Validate date format (MM-DD-YYYY)
        // const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
        // if (!dateRegex.test(newBatchDate)) {
        //     throw new Error("Batch date must be in YYYY-MM-DD format");
        // }

        // Create request body dynamically
        const requestBody = {
            newBatchNumber,
            newBatchDate
        };

        // Get the endpoint
        const endpoint = AccountService_ApiEndPoint.UpdateBatchDetails(tallyUploadId);

        // Make the PATCH request
        const response = await apiClient.patch(endpoint, requestBody);

        return response.data;

    } catch (error) {
        console.error(`Error updating batch details for tally upload ${tallyUploadId}:`, error);
        throw error;
    }
};


// Package Costs
export const GetPackageCost = async (jobId) => {
    try {

        const costsCategoryId = 1;

        const response = await apiClient.get(
            `${AccountService_ApiEndPoint.GetCostPackageByJobId}/${jobId}/${costsCategoryId}`
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching package cost:", error);
        throw error;
    }
};

//Get Cost Summary
export const GetCostSummary = async (jobId) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetCostSummary(jobId)
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching cost summary:", error);
        throw error;
    }
};

//Postage Cost

export const GetPostageCost = async (jobId) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetPostageCost(jobId)
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching get postage cost for job ${jobId}:`, error);
        throw error;
    }
};
export const UpdatePostageCostBulk = async (jobId, data) => {
    console.log("data", data);
    try {
        const url = AccountService_ApiEndPoint.UpdatePostageCost(jobId);

        if (!data || !Array.isArray(data)) {
            throw new Error('Invalid data format. Expected an array.');
        }

        const postageUpdates = data.map(item => ({
            jobCostId: item.jobCostId,
            postageId: item.postageId,
            poNumber: item.poNumber || '',
            estimatedQuantity: Number(item.estimatedQuantity) || 0,
            estimatedCost: Number(item.estimatedCost) || 0,  
            isEstimatedCostPerThousand: item.isEstimatedCostPerThousand ?? false,
            clientEstimateInvoiceNumber: item.clientEstimateInvoiceNumber || '',
            clientEstimateRateType: item.clientEstimateRateType || 'F',
            totalClientEstimate: Number(item.totalClientEstimate) || 0,
            clientEstimate: Number(item.clientEstimate) || 0,
            isClientEstimatePerThousand: item.isClientEstimatePerThousand ?? (item.clientEstimateRateType === 'M'),
            preInvoiceNumber: item.preInvoiceNumber || '',
            actualQuantity: Number(item.actualQuantity) || 0,
            actualCost: Number(item.actualCost) || 0,
            isActualCostPerThousand: item.isActualCostPerThousand ?? false,
            status: Boolean(item.status),
            vendor: item.vendor || '',
            invoiceNumber: item.invoiceNumber || '',
            inboundEstimatedCost: Number(item.inboundEstimatedCost) || 0
        }));

        const requestBody = {
            jobId: jobId,
            postageUpdates: postageUpdates
        };

        const response = await apiClient.put(url, requestBody);
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error('API Error Response:', error.response.data);
        }
        throw error;
    }
};
//Backend Cost

export const GetBackendCost = async (jobId) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetBackendCostById(jobId)
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching get postage cost for job ${jobId}:`, error);
        throw error;
    }
}

// Add this function to your accountService.js file
export const CreateBackendCost = async (requestData) => {
    try {

        const payload = {
            items: requestData
        };

        console.log('Sending payload:', payload);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateCostPackage,
            payload
        );
        return response.data;
    } catch (error) {
        console.error('Error creating cost package:', error);
        throw error;
    }
};

// UPDATE - Update existing backend costs
export const UpdateBackendCost = async (requestData, routeJobId) => {
    try {
        // Ensure each item has the correct jobID AND remove any existing jobID from items
        const normalizedItems = requestData.map(item => {
            // Create new object without jobID first (if it exists)
            const { jobID, ...itemWithoutJobId } = item;
            return {
                ...itemWithoutJobId,
                jobID: Number(routeJobId)  // Add correct jobID
            };
        });

        // Backend expects { jobID, items } format
        const payload = {
            jobID: Number(routeJobId),  // Root level jobID
            items: normalizedItems       // Items with jobID inside
        };

        // console.log('Updating payload (correct format):', JSON.stringify(payload, null, 2));
        // console.log('Route JobID:', routeJobId);

        const response = await apiClient.put(
            AccountService_ApiEndPoint.UpdateCostPackageByJobId(routeJobId),
            payload
        );
        return response.data;
    } catch (error) {
        console.error('Error updating cost package:', error);
        throw error;
    }
};


/* =========================
   CREATE PACKAGE COSTS
========================= */
export const createPackageCosts = async (requestData) => {
    try {
        // Wrap array in items object as backend expects
        const payload = {
            items: requestData  // requestData already array hai
        };

        // console.log('Sending payload:', payload); // Debug ke liye

        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateCostPackage,
            payload  // Ab yeh { items: [...] } format mein jayega
        );
        return response.data;
    } catch (error) {
        console.error('Error creating cost package:', error);
        throw error;
    }
};

/* =========================
   UPDATE PACKAGE COSTS
========================= */

export const updatePackageCosts = (jobID, payload) => {
    return apiClient.put(AccountService_ApiEndPoint.UpdateCostPackageByJobId(jobID), payload);
};
/* =========================
   DELETE PACKAGE COSTS
========================= */

export const DeletePackageCosts = async (requestData) => {
    // console.log("requestData", requestData)
    try {
        const response = await apiClient.delete(
            AccountService_ApiEndPoint.DeleteByCostCategoryId,
            {
                data: requestData
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error deleting package cost rows:', error);
        throw error;
    }
};

export const GetListCostsData = async (jobId) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetListCosts(jobId)
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching get lists costs for job ${jobId}:`, error);
        throw error;
    }
}

export const UpdateListsCostsData = async (jobId, data) => {
    try {
        const url = AccountService_ApiEndPoint.UpdateListsCosts(jobId);

        if (!data || !Array.isArray(data)) {
            throw new Error('Invalid data format. Expected an array.');
        }
        const listUpdates = data.map((item) => ({
            jobCostID: item.jobCostID ?? null,
            mailDetailID: item.mailDetailID,
            listTypeID: item.listTypeID ?? null,

            // Client estimate
            preInvoiceNumber: item.preInvoiceNumber || '',
            preInvoiceCost: Number(item.preInvoiceCost) || 0,
            orderNumber: String(item.orderNumber) || '',
            orderQuantity: Number(item.orderQuantity) || 0,
            isPreInvoiceCostPerThousand: Boolean(item.isPreInvoiceCostPerThousand),

            // Estimated
            estimatedQuantity: Number(item.estimatedQuantity) || 0,
            estimatedCost: Number(item.estimatedCost) || 0,
            isEstimatedCostPerThousand: Boolean(item.isEstimatedCostPerThousand),

            // Actual
            actualQuantity: Number(item.actualQuantity) || 0,
            actualCost: Number(item.actualCost) || 0,
            isActualCostPerThousand: Boolean(item.isActualCostPerThousand),

            // Status
            isCostFinal: Boolean(item.isCostFinal),
        }));

        const requestBody = {
            jobId,
            listUpdates,
        };
        const response = await apiClient.put(url, requestBody?.listUpdates);
        return response.data;
    } catch (error) {
        throw error;
    }
};


//List Of list api 


export const GetTemplateOfLoL = async () => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetTemplateListOfList,
            { responseType: 'arraybuffer' }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching template of list of list:", error);
        throw error;
    }
};

export const UploadListOfList = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.UploadListOfList,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error uploading list of list:", error);
        throw error;
    }
};


export const GetListOfListDetails = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetListOfListDetails);
        return response.data;
    } catch (error) {
        console.error("Error fetching list of list:", error);
        throw error;
    }
};

export const GetBatchDetailsListOfList = async (jobId, versionNumber = null) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetBatchDetailsListOfList(jobId, versionNumber)
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching batch details:", error);
        throw error;
    }
};

export const GetListOfListsVersions = async (jobId) => {
    console.log("Fetching versions for jobId:", jobId);
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetLoLVersions(jobId)
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching batch details:", error);
        throw error;
    }
};

export const UploadClientProfilePicture = async (clientId, file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await apiClient.post(
            AccountService_ApiEndPoint.UploadClientProfilePicture(clientId),
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error uploading profile picture:", error);
        throw error;
    }
};


export const GetClientProfilePicture = async (clientId) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetClientProfilePicture(clientId)
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching batch details:", error);
        throw error;
    }
};

export const DeleteClientProfile = async (clientId) => {
    try {
        const url = AccountService_ApiEndPoint.DeleteCLientProfilePicture(clientId);

        console.log(`Deactivating client with ID ${clientId}`);
        console.log(`Full URL: ${url}`);

        const response = await apiClient.delete(url);

        return response.data;
    } catch (error) {
        throw error;
    }
};


export const CostTypePackageCost = async (payload) => {
    try {
        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreatePackageCostType,
            payload
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching cost types:', error);
        throw error;
    }
};


export const GetJobDetailsReportData = async (clientId) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetJobDetailsReportData(clientId)
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching batch details:", error);
        throw error;
    }
};


// List Name  Maintainance


export const GetListManagers = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetListManagers);
        return response.data;


    } catch (error) {
        throw error;
    }
};


export const GetListSelectManagerment = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetListSelectManagerment);
        return response.data;


    } catch (error) {
        throw error;
    }
};

export const GetClientSelectedData = async (userId) => {

    try {

        const userDataString = localStorage.getItem('userData');

        if (!userDataString) {
            throw new Error('User not authenticated. Please login again.');
        }

        const userData = JSON.parse(userDataString);
        const userId = userData.userId;

        if (!userId) {
            throw new Error('User ID not found. Please login again.');
        }
        const url = `${AccountService_ApiEndPoint.GetReportsFiltersData}?id=${userId}`;

        const response = await apiClient.get(url);
        return response.data.data;



    } catch (error) {
        throw error;
    };
};

export const GetFilterJobByJobId = async (clientIDs) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetFiltersJobByJobId(clientIDs)
        );
        return response?.data?.data;
    } catch (error) {
        throw error;
    }
};


export const GetReportsJobTypes = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetReportsJobTypes);
        return response.data;

    } catch (error) {
        throw error;
    }
};


export const GetFilterJobDetails = async (filters = {}) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetFiltersJobReportJobDetails(filters)
        );
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const GetFilterJobDaily = async (filters = {}) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetFiltersJobReportJobDaily(filters)
        );
        return response?.data;
    } catch (error) {
        console.error("Error fetching batch details:", error);
        throw error;
    }
};

export const GetListMaintainance = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetListMaintainance);
        return response.data;


    } catch (error) {
        throw error;
    }
};

export const CreateListMaintainance = async (payload) => {
    try {
        const response = await apiClient.post(
            AccountService_ApiEndPoint.CreateListMaintainance,
            payload
        );

        return response.data;
    } catch (error) {
        console.error('Error creating list maintenance:', error);
        throw error;
    }
};


export const UpdateListMaintainance = async (payload) => {
    try {
        const { listMasterID } = payload;

        const response = await apiClient.put(
            AccountService_ApiEndPoint.UpdateListMaintainance(listMasterID),  // ✅ CALL with listId
            payload
        );

        return response.data;
    } catch (error) {
        console.error('Error updating list maintenance:', error);
        throw error;
    }
};


export const DeleteListMaintainance = async (listMasterID) => {
    try {
        const url = AccountService_ApiEndPoint.DeleteListMaintainance(listMasterID);

        const response = await apiClient.delete(url);
        return response.data;
    }
    catch (error) {
        console.error('Error deleting list maintenance:', error);
        throw error;
    }
}


// export const GetReportsLol = async (clientIDs) => {
//     try {
//         const response = await apiClient.get(
//             AccountService_ApiEndPoint.GetReportsLol(clientIDs)
//         );
//         return response?.data;
//     } catch (error) {
//         console.error("Error fetching batch details:", error);
//         throw error;
//     }
// };

// ✅ FIXED - Now accepts filters object
export const GetReportsLol = async (filters) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetReportsLol,
            { params: filters }  // ✅ Query params
        );
        return response?.data;
    } catch (error) {
        console.error("Error fetching List of Lists:", error);
        throw error;
    }
};

export const GetClientResults = async (filters) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetClientResults(),
            {
                params: {
                    ...filters,
                    clientIds: filters.clientIds?.join(",")   // ✅ FIX
                }
            }
        );
        return response?.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};



export const GetCostReport = async (filters) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetCostReport(),
            { params: filters }
        );
        return response?.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// export const GetMonthlyMailVolume = async (filters) => {
//     try {
//         const response = await apiClient.get(
//             AccountService_ApiEndPoint.GetMonthlyMailVolume(),
//             { params: filters }  // axios automatically encodes params
//         );
//         return response?.data;
//     } catch (error) {
//         console.error(error);
//         throw error;
//     }
// };

export const GetMonthlyMailVolume = async (filters) => {
    try {
        // Ensure jobIDs are included in the payload
        const payload = {
            ClientIds: filters.ClientIds || "",      // ✅ Capital C
            JobIDs: filters.JobIDs || "",           // ✅ Capital J
            MailStartDate: filters.MailStartDate || "",
            MailEndDate: filters.MailEndDate || "",
        };

        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetMonthlyMailVolume(),
            { params: payload }  // axios automatically encodes params
        );
        return response?.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// list analysis header

// export const GetReportsListAnalysisHeadersGrid = async () => {
//     try {
//         const response = await apiClient.get(
//             AccountService_ApiEndPoint.GetReportsListAnalysisHeader()
//         );
//         return response?.data;
//     } catch (error) {
//         console.error("Error fetching batch details:", error);
//         throw error;
//     }
// };

// // list analysis detail detail
// export const GetReportListAnalysisDetailData = async () => {
//     try {
//         const response = await apiClient.get(
//             AccountService_ApiEndPoint.GetReportlistAnalysisDetail()
//         );
//         return response?.data;
//     } catch (error) {
//         console.error("Error fetching batch details:", error);
//         throw error;
//     }
// };

export const GetReportsListAnalysisHeadersGrid = async (filters = {}) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetReportsListAnalysisHeader(),
            { params: filters }   // ✅ SAME as GetReportsLol
        );
        return response?.data;
    } catch (error) {
        console.error("Error fetching header:", error);
        throw error;
    }
};


export const GetReportListAnalysisDetailData = async (filters = {}) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetReportlistAnalysisDetail(),
            { params: filters }
        );
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const GetRevenueReportData = async (filters = {}) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetRevenueReport(),
            { params: filters }
        );
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const GetTrendAnalysisReport = async (filters = {}) => {
    try {
        const response = await apiClient.get(
            AccountService_ApiEndPoint.GetTrendAnalysisReport(),
            { params: filters }
        );
        return response?.data;
    } catch (error) {
        throw error;
    }
};



export const GetReportsCostTypesData = async () => {
    try {
        const response = await apiClient.get(AccountService_ApiEndPoint.GetReportsCostTypes);
        return response.data;

    } catch (error) {
        throw error;
    }
};